import { createTheme, } from '@mui/material/styles';
import { CEDAR_TITANS_COLOR } from './Constants';
const base = createTheme({})

export const getTheme = (darkMode = false) => {
    let theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            brandcolor: base.palette.augmentColor({
                color: {
                    main: CEDAR_TITANS_COLOR,
                },
                name: 'brandcolor'
            }),
            primary: base.palette.augmentColor({
                color: {
                    main: CEDAR_TITANS_COLOR,
                },
                name: 'primary'
            }),
            green: {
                light: '#4caf50',
                main: '#2e7d32',
                dark: '#1b5e20',
                contrastText: '#ffffff'
            },
            orange: base.palette.augmentColor({
                color: {
                    main: '#EE8434',
                },
                name: 'orange'
            }),
            lightOrange: base.palette.augmentColor({
                color: {
                    'main': '#E0BE36',
                },
                name: 'lightOrange'
            }),
            grey: {
                light: '#CFCFCF',
                main: '#B1B1B1',
                dark: '#9E9E9E',
                contrastText: '#ffffff'
            },
            backgroundColor: base.palette.augmentColor({
                color: {
                    main: darkMode ? '#121212' : '#eaeff1',
                    light: darkMode ? '#333333' : '#f0f3f5',
                    dark: darkMode ? '#0d0d0d' : '#d6dbdb',
                },
                name: 'backgroundColor'
            }),
            background: {
                default: darkMode ? '#121212' : '#eaeff1',
                paper: darkMode ? '#121212' : '#eaeff1'
            }
        },
        typography: {
            h5: {
                fontWeight: 500,
                fontSize: 26,
                letterSpacing: 0.5,
            },
        },
        shape: {
            borderRadius: 8,
        },
        components: {
            MuiTab: {
                defaultProps: {
                    disableRipple: true,
                },
            },
        },
        mixins: {
            toolbar: {
                minHeight: 48,
            },
        },
    });

    return {
        ...theme,
        components: {
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        backgroundColor: '#081627',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                    },
                    contained: {
                        // boxShadow: 'none',
                        // '&:active': {
                        //     boxShadow: 'none',
                        // },
                    },
                },
            },
            MuiTabs: {
                styleOverrides: {
                    root: {
                        // marginLeft: theme.spacing(1),
                    },
                    indicator: {
                        height: 3,
                        borderTopLeftRadius: 3,
                        borderTopRightRadius: 3,
                    },
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        margin: '0 16px',
                        minWidth: 0,
                        padding: 0,
                        [theme.breakpoints.up('md')]: {
                            padding: 0,
                            minWidth: 0,
                        },
                    },
                },
            },
            MuiTabPanel: {
                styleOverrides: {
                    root: {
                        padding: 12
                    }
                }
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        padding: theme.spacing(1),
                    },
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        borderRadius: 4,
                    },
                },
            },
            MuiDivider: {
                styleOverrides: {
                    root: {
                        backgroundColor: 'rgb(255,255,255,0.15)',
                    },
                },
            },
            MuiListItemButton: {
                styleOverrides: {
                    root: {
                        '&.Mui-selected': {
                            color: CEDAR_TITANS_COLOR,
                        },
                    },
                },
            },
            MuiListItemText: {
                styleOverrides: {
                    primary: {
                        fontSize: 14,
                        fontWeight: theme.typography.fontWeightMedium,
                    },
                },
            },
            MuiListItemIcon: {
                styleOverrides: {
                    root: {
                        color: 'inherit',
                        minWidth: 'auto',
                        marginRight: theme.spacing(2),
                        '& svg': {
                            fontSize: 20,
                        },
                    },
                },
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        width: 32,
                        height: 32,
                    },
                },
            },
        },
    };
}